import { DOCUMENT, Injectable, inject } from '@angular/core';

import { LOCAL_STORAGE_KEY } from '../constant/local-storage.constant';

@Injectable({ providedIn: 'root' })
export class TokenStoreService {
    private readonly document = inject(DOCUMENT);

    read(): string | null {
        return this.storage?.getItem(LOCAL_STORAGE_KEY.AUTH_TOKEN) ?? null;
    }

    save(token: string): void {
        this.storage?.setItem(LOCAL_STORAGE_KEY.AUTH_TOKEN, token);
    }

    clear(): void {
        this.storage?.removeItem(LOCAL_STORAGE_KEY.AUTH_TOKEN);
    }

    private get storage(): Storage | undefined {
        return this.document.defaultView?.localStorage;
    }
}
